import { AsyncPipe, NgClass, NgIf } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';
import { Observable } from 'rxjs';
import { GlobalSpinnerService } from './global-spinner.service';

@Component({
  selector: 'curbnturf-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  standalone: true,
  imports: [NgIf, NgClass, AsyncPipe],
})
export class SpinnerComponent implements OnChanges {
  @Input() show: boolean;
  @Input() cntWidth: string;

  classes: string;

  global$: Observable<boolean>;

  constructor(private globalSpinnerService: GlobalSpinnerService) {}

  ngOnInit() {
    this.global$ = this.globalSpinnerService.spinner$;
  }

  ngOnChanges() {
    if (this.cntWidth) {
      this.classes = '';
    }

    this.classes = 'right-0';
  }
}
